import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserContext } from '../context/user';
import { useSignOut } from '../hooks/useSignOut';

const RoleBasedRedirect: React.FC = () => {
    const { role, jwtToken, layout } = useUserContext();
    const [redirectPath, setRedirectPath] = useState<string | null>(null);

    const signOut = useSignOut();

    useEffect(() => {
        if (!jwtToken) {
            setRedirectPath('/sign_in/refresh_token');
        } else if (layout === null) {
            // NOTE: Disable layout
            signOut()
            // setRedirectPath('/layout');
        } else if (layout === 'ADMIN') {
            setRedirectPath('/daily');
        } else if (layout === 'MANAGER') {
            setRedirectPath('/claims');
        } else {
            setRedirectPath(null);
        }
    }, [role]);

    if (redirectPath) {
        return <Navigate to={redirectPath} replace />;
    }

    return <div className="mt-4 w-full flex flex-col justify-center items-center">
        <div className="text-red-500 font-bold">Неизвестная роль</div>
        <button
            className='
            w-48
            h-10
            inline-flex
            items-center
            justify-center
            flex-[0_0_auto]
            rounded-lg gap-2.5 px-5 py-4
            relative
            font-manager-acrom-ph1-18-medium-acrom
            font-[number:var(--manager-acrom-ph1-18-medium-acrom-font-weight)]
            text-[length:var(--manager-acrom-ph1-18-medium-acrom-font-size)]
            text-center
            tracking-[var(--manager-acrom-ph1-18-medium-acrom-letter-spacing)]
            leading-[var(--manager-acrom-ph1-18-medium-acrom-line-height)]
            [font-style:var(--manager-acrom-ph1-18-medium-acrom-font-style)]
            bg-melon-yellow'

            onClick={signOut}
        >Выйти
        </button>
    </div>;
};

export default RoleBasedRedirect;


